import CreatePollModal from './CreatePollModal';
import PostPoll from './PostPoll';
import EditPollModal from './EditPollModal';
import ListVotersModal from './ListVotersModal';

export const components = {
  CreatePollModal,
  PostPoll,
  EditPollModal,
  ListVotersModal,
};
